import { useQuery, gql } from './graphql-provider';
import { Elm_Enum_Pitch_Class, Elm_Enum_Pitch_Class_Bool_Exp } from '../../../gen/types';

const PITCH_CLASSES_QUERY = gql`
  query GetPitchClasses($where: elm_enum_pitch_class_bool_exp) {
    pitchClasses: elm_enum_pitch_class(where: $where) {
      description
      order_rel {
        order
      }
      value
    }
  }
`;

export function useQueryPitchClasses({where}: {where: Elm_Enum_Pitch_Class_Bool_Exp}) {
  const { loading, error, data } = useQuery<
    {pitchClasses: Array<Elm_Enum_Pitch_Class>},
    {where: Elm_Enum_Pitch_Class_Bool_Exp}
  >(PITCH_CLASSES_QUERY, {
    variables: {where}
  });

  return {
    data: data ? data.pitchClasses : null,
    error,
    loading,
  };
}
